/**
 * Import constants
 */
import { GET_EVENTS_DATA, GET_EVENTS_DATA_PENDING, GET_EVENTS_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: [],
	error: null
};

/**
 * Message events reducer
 * @param {*} state
 * @param {*} action
 */
export const messageEventsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_EVENTS_DATA_PENDING:
			return {
				...state,
				loading: true
			};
		case GET_EVENTS_DATA:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			};
		case GET_EVENTS_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
